// Write your code here
import './index.css'

const TabItem = props => {
  const {tabDetails, setActiveTabId, isActive} = props
  const {displayText, tabId} = tabDetails

  const onClickTabId = () => {
    setActiveTabId(tabId)
  }
  const tabBtnClassName = isActive ? 'tab-btn active' : 'tab-btn'

  return (
    <>
      <li className="tab-item">
        <button
          type="button"
          onClick={onClickTabId}
          className={tabBtnClassName}
        >
          {displayText}
        </button>
      </li>
    </>
  )
}

export default TabItem
